export default function authHeader (token) {
  if (token) {
    return { Authorization: 'Bearer ' + token, accept: 'application/json' }
  } else {
    return {}
  }
}
